module.exports = __webpack_public_path__ + "static/img/9.207b82a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/9.png
// module id = Ot6K
// module chunks = 0